import { orderStatusInformationStyles as styles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusInformation";
import { typography } from "@solveindustrial/Utilities/styleguide";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.informationWrapper = {
    ...styles.informationWrapper,
    css: css`
        ${styles.informationWrapper?.css}
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 10px;

        ${mediaQueriesBP.minMD} {
            flex-direction: row;
        }
    `,
};

styles.titleText = {
    ...styles.titleText,
    variant: "h4",
    forwardAs: "h4",
};

styles.orderNumberText = {
    ...styles.orderNumberText,
    ...typography.body,
    css: css`
        ${styles.orderNumberText?.css};
        ${typography.body.css}
    `,
    mergeCss: true,
};

styles.statusText = {
    ...styles.statusText,
    ...typography.body,
    css: css`
        ${styles.statusText?.css};
        ${typography.body.css}
    `,
    mergeCss: true,
};

styles.orderDateText = {
    ...styles.orderDateText,
    ...typography.body,
    css: css`
        ${styles.orderDateText?.css};
        ${typography.body.css}
    `,
    mergeCss: true,
};

styles.termsText = {
    ...styles.termsText,
    ...typography.body,
    css: css`
        ${styles.termsText?.css};
        ${typography.body.css}
    `,
    mergeCss: true,
};

styles.poNumberText = {
    ...styles.poNumberText,
    ...typography.body,
    css: css`
        ${styles.poNumberText?.css};
        ${typography.body.css}
    `,
    mergeCss: true,
};

styles.shippingMethodText = {
    ...styles.shippingMethodText,
    ...typography.body,
    css: css`
        ${styles.shippingMethodText?.css};
        ${typography.body.css}
    `,
    mergeCss: true,
};

styles.vatNumberText = {
    ...styles.vatNumberText,
    ...typography.body,
    css: css`
        ${styles.vatNumberText?.css};
        ${typography.body.css}
    `,
    mergeCss: true,
};
